import { render, staticRenderFns } from "./FNLEnglish.vue?vue&type=template&id=0b50289e"
import script from "./FNLEnglish.vue?vue&type=script&lang=js"
export * from "./FNLEnglish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports